module.exports = __webpack_public_path__ + "img/تين-صورة.8210109e.png";